import { ValidationMessage } from 'ui';
import { ListBranch } from '../types-store';
import { GroupedError } from '../types';

export const getGroupedErrors = (
  listBranch: ListBranch[],
  actionErrors: ValidationMessage[]) =>
  actionErrors?.reduce(
    (results, error) => {

      const id = error.parameters?.userId;
      const codeDescription = listBranch
        ?.find(branch => branch.items?.some(item => item.id === id))
        ?.items?.find(item => item.id === id)
        ?.description;

      if (!codeDescription) {
        return results;
      }

      const existingResult = results.find(result => result.message === error.message);

      if (existingResult) {

        return existingResult.descriptions.some(description => description === codeDescription)
          ? results
          : results.map(result => result === existingResult
            ? {
              ...result,
              descriptions: [
                ...result.descriptions,
                codeDescription
              ]
            }
            : result);
      }

      return [
        ...results,
        {
          message: error.message,
          descriptions: [codeDescription]
        }
      ];
    },
    [] as GroupedError[]
  ) ?? [];
